import request from '@/utils/request';

export function getPopularSearchKey(type) {
  return request({
    url: '/Search/getPopularKey',
    params: {
      type,
    },
    silentRequest: true,
  });
}

export function getSearchResult(params) {
  return request({
    url: '/Search/index',
    params,
  });
}

export function getSearchResultList(params) {
  return request({
    url: '/Search/explore',
    params,
  });
}
